import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

import { GRADIENT_LANDING_MOZZA } from '@/designSystem/theme';

export default makeStyles()(() => ({
  container: {
    textAlign: 'center',
    padding: `${rem(8)} ${rem(12)}`,
    borderRadius: rem(8),
    background: GRADIENT_LANDING_MOZZA,
  },
}));
